import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class ApproveSalesOrderService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    // Check for problems creating the tag.
    if (activity?.error) {
      return this.tableEntry(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.APPROVE_SALES_ORDER.ACTIVITY.FAILED'),
        this.emptyBody(),
      );
    }

    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.APPROVE_SALES_ORDER.ACTIVITY.TITLE'),
      this.emptyBody(),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.APPROVE_SALES_ORDER.ACTION.TITLE'),
      this.noValidationErrorsDetected(),
    );
  }
}
